const ROUTE_PATH_LANDINGPAGE = "/";
const ROUTE_PATH_HOMEPAGE = "/home";
const ROUTE_PATH_TRASHPAGE = "/trash";
const ROUTE_PATH_ARCHIVEPAGE = "/archive";
const ROUTE_PATH_LABELPAGE = "/label";
const ROUTE_PATH_Unknown = "*";
const ROUTE_PATH_LOGINPAGE = "/login";
const ROUTE_PATH_SIGNUPPAGE = "/signup";
const ROUTE_PATH_PROFILEPAGE = "/profile";
const ROUTE_PATH_Mockman = "/mockman";

const VAR_ENCODE_TOKEN = "NotesifyToken";
const VAR_USER_ID = "NotesifyUserId";
const VAR_USER_DETAILS = "NotesifyUserDetails";

const VAR_PINNED_NOTES = "pinned";
const VAR_NOTPINNED_NOTES = "notpinned";
const VAR_RESET = "reset";
export {
	ROUTE_PATH_LANDINGPAGE,
	ROUTE_PATH_HOMEPAGE,
	ROUTE_PATH_TRASHPAGE,
	ROUTE_PATH_ARCHIVEPAGE,
	ROUTE_PATH_LABELPAGE,
	ROUTE_PATH_Unknown,
	ROUTE_PATH_LOGINPAGE,
	ROUTE_PATH_SIGNUPPAGE,
	ROUTE_PATH_PROFILEPAGE,
	ROUTE_PATH_Mockman,
	VAR_ENCODE_TOKEN,
	VAR_USER_ID,
	VAR_USER_DETAILS,
	VAR_PINNED_NOTES,
	VAR_NOTPINNED_NOTES,
	VAR_RESET,
};
